const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTxSubmitted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: -74.5,
    y1: 32,
    x2: 59,
    y2: 52.5,
    gradientTransform: "matrix(1.315789,0,0,1.315789,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F62FF",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B5BD2",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 100 50 C 100 77.613281 77.613281 100 50 100 C 22.386719 100 0 77.613281 0 50 C 0 22.386719 22.386719 0 50 0 C 77.613281 0 100 22.386719 100 50 Z M 100 50 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 34.691406 43.890625 C 35.640625 44.847656 37.171875 44.847656 38.117188 43.890625 L 47.570312 34.386719 L 47.570312 71.550781 C 47.570312 72.898438 48.664062 74 50.003906 74 C 51.339844 74 52.433594 72.898438 52.433594 71.550781 L 52.433594 34.359375 L 61.863281 43.867188 C 62.808594 44.820312 64.339844 44.820312 65.289062 43.867188 C 66.234375 42.910156 66.234375 41.367188 65.289062 40.410156 L 51.703125 26.71875 C 50.753906 25.761719 49.226562 25.761719 48.277344 26.71875 L 34.691406 40.410156 C 33.769531 41.367188 33.769531 42.933594 34.691406 43.890625 Z M 34.691406 43.890625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxSubmitted);
export default __webpack_public_path__ + "static/media/tx-submitted.632844b521aa32f7411f6c99126ac21d.svg";
export { ForwardRef as ReactComponent };